import { UserAvatar } from "~/users/user-avatar"
import { GroupInvitationQuery } from "~/__generated__/graphql"

type GroupType = NonNullable<GroupInvitationQuery["groupInvitation"]>["group"]

interface GroupOverviewItemProps {
  group: GroupType
}

export const GroupOverviewItem = ({ group }: GroupOverviewItemProps) => {
  return (
    <div className="flex h-full flex-col rounded-sm border bg-white p-4 transition-colors hover:border-gray-400">
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <UserAvatar user={group.creator} className="h-6 w-6 text-xs" />
          <div>
            <div className="text-xs text-subdued">
              by <span className="text-foreground">{group.creator.fullName}</span>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <h3 className="truncate text-lg font-semibold">{group.name}</h3>
          {group.description && (
            <p className="mt-2 line-clamp-2 text-sm font-medium text-subdued">
              {group.description}
            </p>
          )}
        </div>
        <div className="mb-2 mt-6 flex gap-1">
          {group.members.nodes.map((groupMember) => (
            <UserAvatar key={groupMember.id} user={groupMember} className="h-6 w-6 text-xs" />
          ))}
        </div>
      </div>

      <hr className="my-4 border-gray-200" />
      <div className="space-y-2 text-xs">
        <div className="flex">
          <div className="mr-2 text-subdued">Bookmarks:</div>
          <div className="font-medium">{group.bookmarksVisibleCount}</div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-4">
        {group.bookmarks.nodes.map((bookmark) => (
          <img
            key={bookmark.id}
            className="col-span-1 rounded-md"
            src={bookmark.enrichment?.screenshotUrl || ""}
            alt={`${bookmark.title} screenshot`}
          />
        ))}
      </div>
    </div>
  )
}
